import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { Layout } from "@/components/Layout";
import Home from "@/pages/Home";
import LaPalestra from "@/pages/LaPalestra";
import SalaPesi from "@/pages/SalaPesi";
import PersonalTraining from "@/pages/PersonalTraining";
import CorsiFitness from "@/pages/CorsiFitness";
import SalaOlistica from "@/pages/SalaOlistica";
import KidsFamily from "@/pages/KidsFamily";
import Professionisti from "@/pages/Professionisti";
import Abbonamenti from "@/pages/Abbonamenti";
import Contatti from "@/pages/Contatti";
import CorsoDetail from "@/pages/CorsoDetail";

function App() {
  return (
    <div className="App">
      <Toaster position="top-center" richColors />
      <BrowserRouter>
        <Routes>
          <Route element={<Layout />}>
            <Route path="/" element={<Home />} />
            <Route path="/la-palestra" element={<LaPalestra />} />
            <Route path="/sala-pesi" element={<SalaPesi />} />
            <Route path="/personal-training" element={<PersonalTraining />} />
            <Route path="/corsi-fitness" element={<CorsiFitness />} />
            <Route path="/sala-olistica" element={<SalaOlistica />} />
            <Route path="/kids-family" element={<KidsFamily />} />
            <Route path="/professionisti" element={<Professionisti />} />
            <Route path="/abbonamenti" element={<Abbonamenti />} />
            <Route path="/contatti" element={<Contatti />} />
            <Route path="/corsi/:slug" element={<CorsoDetail />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
